import React, { useRef, useEffect } from 'react';
import { MenuProps, components, InputActionMeta } from 'react-select';
import { SelectOption } from '../../..';

const Component = components.Menu;

const TransparentMenu = (props: MenuProps<SelectOption>) => {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current?.focus();
    }
  }, [ref.current]);

  return (
    <div className='custom-menu'>
      <Component {...props}>
        <input
          ref={ref}
          style={{
            width: '100%',
            boxSizing: 'border-box',
            padding: 10,
            border: 'none',
            borderBottom: '1px solid lightgrey',
            borderTopLeftRadius: '5px',
            borderTopRightRadius: '5px',
          }}
          autoCorrect='off'
          autoComplete='off'
          spellCheck='false'
          type='text'
          value={props.selectProps.inputValue}
          onChange={(event) => {
            const action: InputActionMeta = {
              action: 'input-change',
              prevInputValue: props.selectProps.inputValue,
            };

            props.selectProps.onInputChange(event.target.value, action);
          }}
          onMouseDown={(e) => {
            e.stopPropagation();
            (e.target as HTMLInputElement).focus();
          }}
          placeholder='Search...'
        />
        {props.children}
      </Component>
    </div>
  );
};

export default TransparentMenu;
